// extracted by mini-css-extract-plugin
export var chevronIcon = "_ar-2";
export var teamName = "_ar-1";
export var teamSwitcherButton = "_ar-0";